import actions from './actions'

const permissions = (state = { canViewCompanies: false }, action) => {
  switch (action.type) {
    case actions.setPermissions:
      return Object.assign({}, state.permissions, action.permissions)
    default:
      return state
  }
}

export default permissions



// WEBPACK FOOTER //
// ./src/store/permissions/reducer.js